export interface PatientLabelNameSource {
  firstName?: string | null;
  lastName?: string | null;
}

const PATIENT_NAME_PLACEHOLDERS = new Set(["unknown", "unknown patient"]);

/**
 * Resolve a printable patient name from the first source containing either a
 * first or last name. Sources should be ordered from freshest to stalest.
 */
export function resolvePatientLabelName(
  ...sources: Array<PatientLabelNameSource | null | undefined>
): string | null {
  const source = sources.find(
    (candidate) =>
      !!candidate?.firstName?.trim() || !!candidate?.lastName?.trim()
  );
  const firstName = source?.firstName?.trim() ?? "";
  const lastName = source?.lastName?.trim() ?? "";

  if (lastName && firstName) return `${lastName}, ${firstName}`;
  return lastName || firstName || null;
}

export function isUsablePatientLabelName(
  patientName: string | null | undefined
): boolean {
  const normalized = patientName?.trim().toLowerCase() ?? "";
  if (!normalized || normalized === ",") return false;
  return !PATIENT_NAME_PLACEHOLDERS.has(normalized);
}

export const MISSING_PATIENT_LABEL_NAME_ERROR =
  "Patient name is missing. Enter at least a first or last name before printing this label.";
